import { useEffect } from 'react'

const TIMEOUT = 25000

export function HeartbeatsProvider ({
  timeoutHeartbeat,

  removeHeartbeat
}) {
  useEffect(() => {
    if (timeoutHeartbeat) {
      const timeout = setTimeout(() => {
        removeHeartbeat(timeoutHeartbeat)
      }, Math.max(timeoutHeartbeat.timestamp + TIMEOUT - Date.now(), 0))

      return () => {
        clearTimeout(timeout)
      }
    }
  }, [timeoutHeartbeat, removeHeartbeat])

  return null
}

export default HeartbeatsProvider
